module.exports = __webpack_public_path__ + "a3a578ca9a1a4b95efa5727395175ace.png";